// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2931":"c051d703","6719":"5fed5e5c","8041":"183e386b"}[chunkId] + ".chunk.css";
};